import React from "react";
import { Route, Routes } from "react-router-dom";

import Landing from "./components/landing/Landing";

const Main = () => {
  return (
    <Routes>
      <Route exact path="/" element={<Landing />}></Route>
    </Routes>
  );
};

export default Main;
